import React, { useEffect, useRef, useState } from 'react'
import Showingicon from './components/Showingicon/Showingicon'
import Entwined from './components/Entwined/Entwined'
import Whatfits from './components/Whatfits/Whatfits'
import Fully from './components/Fully/Fully'
import Internetloading from './components/Internetloading/Internetloading'
import Lovefeel from './components/Lovefeel/Lovefeel'
import Lovegrowbygiving from './components/Lovegrowbygiving/Lovegrowbygiving'
import Checkboxtrulymatter from './components/Checkboxtrulymatter/Checkboxtrulymatter'
import Flowers from './components/Flowers/Flowers'
import Twolinecharts from './components/Twolinecharts/Twolinecharts'
import Communication from './components/Communication/Communication'
import { production } from '../../config/constants'
import Rewindtime from './components/Rewindtime/Rewindtime'
import Gottman from './components/Gottman/Gottman'
import './Collection.css'

const bgcolor = production ? 'black' : 'pink'

function Collection(props) {

    const [currshowing, setCurrshowing] = useState(12)
    const p5ref = useRef(null)

    useEffect(() => {
        props.hidetopbar(true)
    }, [])

    return <div
        className={currshowing > 0 ? 'Objectspace_root_show' : 'Objectspace_root'}
        style={currshowing > 0 ? { backgroundColor: 'black', } : { backgroundColor: '#fffef7', padding: 5, height: '100vh' }}
    >
        {currshowing === -1
            ? null
            : <button
                className='Objectspace_backbtn'
                style={{ backgroundColor: currshowing > 0 ? 'black' : '' }}
                onClick={() => {

                    // 1. Hard-remove ALL p5 canvases inside the wrapper
                    const wrappers = document.querySelectorAll(".p5-wrapper");
                    wrappers.forEach((w) => {
                        try { w.innerHTML = ""; } catch { }
                    });

                    const canvas = p5ref.current?.querySelector("canvas");
                    const p5 = canvas?.__p5__;

                    if (p5 && typeof p5.myDestroy === "function") {
                        p5.myDestroy();    // ← STOP EVERYTHING SAFELY
                    }

                    setCurrshowing(-1)

                }}>
                Back
            </button>}

        {/* {currshowing === -1
            ? <div className='Random_btnroot' >
                {!production ? <button className='Random_singlebtn' onClick={() => { setCurrshowing(0) }}>[ Showingicon ] WeaveBliss zoom in icon</button> : null}
                <button className='Random_singlebtn' onClick={() => { setCurrshowing(1) }}>[ Entwined ] The paths converged. The distance closed. All distinction dissolved into one seamless thread.</button>
                <button className='Random_singlebtn' onClick={() => { setCurrshowing(2) }}>[ Whatfits ] Seek the perfect fit, not the perfect shape.</button>
                <button className='Random_singlebtn' onClick={() => { setCurrshowing(3) }}>[ Fully ] A full world beats a fraction of a galaxy.</button>
                <button className='Random_singlebtn' onClick={() => { setCurrshowing(4) }}>[ Internetloading ] Before marrying someone, have them use slow internet to see who they really are.</button>
                <button className='Random_singlebtn' onClick={() => { setCurrshowing(5) }}>[ Lovefeel ] Love is not only something you feel it is something you do.</button>
                <button className='Random_singlebtn' onClick={() => { setCurrshowing(6) }}>[ Lovegrowbygiving ] Love grows by giving.</button>
                <button className='Random_singlebtn' onClick={() => { setCurrshowing(7) }}>[ Checkboxtrulymatter ] A soulmate isn’t about checking every box but the few that truly matter.</button>
                <button className='Random_singlebtn' onClick={() => { setCurrshowing(8) }}>[ Flowers ] </button>
            </div>
            : null} */}

        {currshowing === -1
            ? <div className='Random_btnroot' >
                {/* {!production ? <button className='Random_singlebtn' onClick={() => { setCurrshowing(0) }}>WeaveBliss zoom in icon</button> : null} */}
                {/* <button className='Random_singlebtn' onClick={() => { setCurrshowing(1) }} onMouseMove={() => { }}><div className='Collection_div' /> The paths converged. The distance closed. All distinction dissolved into one seamless thread.</button> */}
                <button className='Random_singlebtn' onClick={() => { setCurrshowing(2) }}>Seek the perfect fit, not the perfect shape.</button>
                <button className='Random_singlebtn' onClick={() => { setCurrshowing(3) }}>A full world beats a fraction of a galaxy.</button>
                <button className='Random_singlebtn' onClick={() => { setCurrshowing(4) }}>Before marrying someone, have them use slow internet to see who they really are.</button>
                <button className='Random_singlebtn' onClick={() => { setCurrshowing(5) }}>Love is not only something you feel it is something you do.</button>
                <button className='Random_singlebtn' onClick={() => { setCurrshowing(6) }}>Love grows by giving.</button>
                <button className='Random_singlebtn' onClick={() => { setCurrshowing(7) }}>A soulmate isn’t about checking every box but the few that truly matter.</button>
                {/* <button className='Random_singlebtn' onClick={() => { setCurrshowing(8) }}>Flowers</button> */}
                <button className='Random_singlebtn' onClick={() => { setCurrshowing(9) }}>Two line charts.</button>
                <button className='Random_singlebtn' onClick={() => { setCurrshowing(10) }}>Communication</button>
                <button className='Random_singlebtn' onClick={() => { setCurrshowing(11) }}>Rewind Time</button>
                <button className='Random_singlebtn' onClick={() => { setCurrshowing(12) }}>Gottman Stability Ratio</button>
            </div>
            : null}

        {{
            0: <Showingicon />,
            1: <Entwined p5ref={p5ref} wt={600} ht={600} scale={0.65} fs={20} bgcolor={bgcolor} />,
            2: <Whatfits p5ref={p5ref} wt={600} ht={600} scale={0.65} fs={20} bgcolor={bgcolor} />,
            3: <Fully p5ref={p5ref} wt={600} ht={600} scale={0.65} fs={20} bgcolor={bgcolor} />,
            4: <Internetloading p5ref={p5ref} wt={600} ht={600} scale={0.65} fs={20} bgcolor={bgcolor} />,
            5: <Lovefeel p5ref={p5ref} wt={600} ht={600} scale={0.65} fs={20} bgcolor={bgcolor} />,
            6: <Lovegrowbygiving p5ref={p5ref} wt={600} ht={600} scale={0.65} fs={20} bgcolor={bgcolor} />,
            7: <Checkboxtrulymatter p5ref={p5ref} wt={600} ht={600} scale={0.65} fs={20} bgcolor={bgcolor} />,
            8: <Flowers p5ref={p5ref} wt={600} ht={600} scale={0.65} fs={20} bgcolor={bgcolor} />,
            9: <Twolinecharts p5ref={p5ref} wt={600} ht={600} scale={0.65} fs={20} bgcolor={bgcolor} />,
            10: <Communication p5ref={p5ref} wt={600} ht={600} scale={0.65} fs={20} bgcolor={bgcolor} />,
            11 : <Rewindtime p5ref={p5ref} wt={600} ht={600} scale={0.65} fs={20} bgcolor={bgcolor} />,
            12 : <Gottman p5ref={p5ref} wt={600} ht={600} scale={0.65} fs={20} bgcolor={bgcolor} />,

        }[currshowing]}

    </div>

}



export default Collection
